import { render, staticRenderFns } from "./bindCanteen.vue?vue&type=template&id=282c113e&scoped=true&"
import script from "./bindCanteen.vue?vue&type=script&lang=js&"
export * from "./bindCanteen.vue?vue&type=script&lang=js&"
import style0 from "./bindCanteen.vue?vue&type=style&index=0&id=282c113e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282c113e",
  null
  
)

export default component.exports